// extracted by mini-css-extract-plugin
module.exports = {"rouge":"#D30943","jaune":"#E6B100","primary":"#025DBF","secondary":"#585858","sucess":"#55A74D","warning":"#E6B100","erreur":"#D30943"};